import { Communication } from "@/features/communication/Communication";
import { History } from "@/features/history/History";
import { NextBestActions } from "@/features/nextBestActions/NextBestActions";
import { NotesSection } from "@/features/notes/NotesSection";
import { useAiFeatureConfig } from "@/features/projects/hooks/useAiFeatureConfig";
import { ActivityActions } from "@/features/tasks/ActivityActions";
import { ActivitySection } from "@/features/tasks/ActivitySection";
import { type Opportunity } from "@repo/api";
import { useSettings } from "@repo/ui";

import { ProjectSummarySection } from "./projectAI/ProjectSummarySection";

interface TaskCardProps {
  opportunity: Opportunity;
  editable: boolean;
}

export const TaskSection = ({ opportunity, editable }: TaskCardProps) => {
  const { feature_flags } = useSettings();

  const showProjectSummary = useAiFeatureConfig({
    feature: "projectSummary",
    buCode: opportunity.customerMeetingPointBuCode,
  });

  return (
    <>
      {showProjectSummary && (
        <ProjectSummarySection opportunity={opportunity} />
      )}
      <ActivityActions opportunity={opportunity} />
      <ActivitySection opportunity={opportunity} editable={editable} />
      {!showProjectSummary && (
        <NextBestActions opportunity={opportunity} editable={editable} />
      )}
      {feature_flags?.enable_customer_communication && (
        <Communication opportunity={opportunity} />
      )}
      <NotesSection opportunity={opportunity} />
      <History opportunity={opportunity} />
    </>
  );
};
